import { STATUS_NEEDS_MORE_INFORMATION } from '../constants/rfp';
import { rfpAPI } from '../services/api';

/** Must match {@link PRE_ONBOARDING_JOURNEY_RETURN_PARAM} in preOnboardingInProgressModel. */
export const RFP_PRE_ONBOARDING_JOURNEY_RETURN_PARAM = 'from_pre_onboarding_journey';

export type RfpListRowMinimal = {
  id: number;
  status?: string | null;
  vendor_initiation_id?: number | null;
};

export type RfpModuleQueryOptions = {
  returnToPreOnboardingJourney?: boolean;
};

export function buildRfpModuleQuery(
  vendorInitiationId?: number | null,
  options?: RfpModuleQueryOptions
): string {
  const parts: string[] = [];
  if (vendorInitiationId != null && vendorInitiationId > 0) {
    parts.push(`vendor_initiation_id=${vendorInitiationId}`);
  }
  if (options?.returnToPreOnboardingJourney) {
    parts.push(`${RFP_PRE_ONBOARDING_JOURNEY_RETURN_PARAM}=1`);
  }
  return parts.length ? `?${parts.join('&')}` : '';
}

export function parseRfpListRows(res: unknown): RfpListRowMinimal[] {
  const data = (res as { data?: unknown })?.data;
  return Array.isArray(data) ? (data as RfpListRowMinimal[]) : [];
}

/** Edit draft / resubmit, or view RFP when already submitted. */
export function buildRfpContinueHref(
  row: Pick<RfpListRowMinimal, 'id' | 'status'>,
  vendorInitiationId?: number | null,
  options?: RfpModuleQueryOptions
): string {
  const st = String(row.status ?? '').toLowerCase();
  const vi = vendorInitiationId != null && vendorInitiationId > 0 ? vendorInitiationId : null;
  if (st === 'draft' || st === STATUS_NEEDS_MORE_INFORMATION) {
    return buildRfpCreateDraftHref(row.id, vi, options);
  }
  return `/vms/rfp-management/${row.id}${buildRfpModuleQuery(vi, options)}`;
}

export function buildRfpCreateDraftHref(
  draftRfpId: number,
  vendorInitiationId?: number | null,
  options?: RfpModuleQueryOptions
): string {
  return `/vms/rfp-management/create/${draftRfpId}${buildRfpModuleQuery(vendorInitiationId, options)}`;
}

/** One RFP per vendor initiation — returns the existing row if any. */
export async function fetchExistingRfpForVendorInitiation(
  vendorInitiationId: number
): Promise<RfpListRowMinimal | null> {
  const res = await rfpAPI.list({
    vendor_initiation_id: vendorInitiationId,
    limit: 1,
    page: 1,
  });
  const rows = parseRfpListRows(res);
  return rows[0] ?? null;
}
